import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
    selectedHeader: 0,
};

export const sideNavSlice = createSlice({
    name: 'leaveModification',
    initialState,
    reducers: {
        setActiveTab: (state, action: PayloadAction<{ id: number }>) => {
            state.selectedHeader = action.payload.id;
        },
    },
});

export const { setActiveTab } = sideNavSlice.actions;
export default sideNavSlice.reducer;
